// extracted by mini-css-extract-plugin
module.exports = {"tag-wrapper":"TagsByRestaurant_tag-wrapper__cDqk8","tag":"TagsByRestaurant_tag__aAIqC"};